import MaterialPaper from '@mui/material/Paper';
import PropTypes from 'prop-types';

const styles = {
  root: {
    mb: 3,
    p: 3,
  },
  tabContent: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  tabTable: {
    '& .MuiDataGrid-root': {
      border: 'none',
    },
    p: 0,
    pb: 1,
    pt: 3,
  },
};

const Paper = ({ children, tabContent = false, tabTable = false }) => (
  <MaterialPaper
    sx={{
      ...styles.root,
      ...(tabContent && styles.tabContent),
      ...(tabTable && styles.tabTable),
    }}
  >
    {children}
  </MaterialPaper>
);

Paper.propTypes = {
  children: PropTypes.any,
  tabContent: PropTypes.bool,
  tabTable: PropTypes.bool,
};

export default Paper;
